import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import Button from '~/src_common/components/parts/button/Button.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'CompleteCrossSellBanner',
  props: {
    discountPercent: null,
    linkText: null,
    linkUrl: null,
    catchText: null
  },
  setup(__props: any) {

const props = __props as {
  discountPercent: number;
  linkText: string;
  linkUrl: string;
  catchText: string;
};

// isDesktop はグローバル mixin（src/main.js=true, src_sp/main.js=false）を
// テンプレートで直接参照する（CompleteStepper.vue / AppDownloadBanner.vue と同様のパターン）。
// 表示するか否かの判定ロジック（isShowCrossSellLink 等）は持たない。呼び出し元
// （payment_completion_screen.js からのブリッジ、design.md 要件13.4/2.6）が
// マウント点の有無・setCrossSellData 経由で表示を制御する。渡された props は
// そのまま描画するのみの静的な visual コンポーネント。
// Figma after 版(PC node 1811-64477 / SP node 1811-64545)はホテル一覧の個別
// カード表示を持たないため、hotelList 相当の props は設けない(要件 13.5)。
// 背景写真(AdobeStock_95358673)は public_html/travelist/{pc,sp}/img/ に実アセットとして配置し
// (他コンポーネントの `/travelist/...` 絶対パス+background-image と同じ慣習)、
// Figma仕様の青オーバーレイ rgba(4,76,210,0.85) を別レイヤーで重ねている。
// PC の background-position を 80% にしているのは、Figma node 1811-64477 の
// 画像配置(top: calc(50% - 165.5px)、コンテナ高208pxに対し画像高757px)を
// 逆算した値。center(50%)のままだと海側の景色しか映らず、Figma が意図する
// 木造建築側の下寄りクロップとずれる。SP(node 1811-64545)は元々ほぼ中央
// クロップのため center のまま。


// discount_headline の4セグメント（テキスト＋PC/SPそれぞれのFigma準拠フォントサイズ・
// 下線太さ）。数値のみが動的(discountPercent)で、他はFigma固定テキスト。
const headlineSegments = computed(() => [
  {
    text: '宿泊料金が最大',
    pc: 'text-[48px] leading-[32px] decoration-[8px]',
    sp: 'text-[24px] leading-[32px] decoration-[3px]',
  },
  {
    text: props.discountPercent,
    dataName: 'discount_percent',
    pc: 'text-[60px] leading-[32px] decoration-[8px]',
    sp: 'text-[32px] leading-[32px] decoration-[3px]',
  },
  {
    text: '%',
    pc: 'text-[48px] leading-[32px] decoration-[8px]',
    sp: 'text-[20px] leading-[32px] decoration-[3px]',
  },
  {
    text: 'オフ!',
    pc: 'text-[48px] leading-[32px] decoration-[8px]',
    sp: 'text-[24px] leading-[32px] decoration-[3px]',
  },
]);

return { __sfc: true,props, headlineSegments, Button }
}

})